import { render } from "./create_feed.html?vue&type=template&id=2dfb827b&external"
import script from "./create_feed.js?vue&type=script&lang=js&external"
export * from "./create_feed.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__